import { createSlice } from "@reduxjs/toolkit";

import { contentInitialState } from "./content.initialState";
import {
  getAllCountries,
  getCountryInfo,
  getHTMLCode,
  getPageContent,
  getProxiesMenu,
  saveCountryInfo,
  serverCountrySave,
  serverMenuProxySave,
  serverSeoSave,
} from "./content.operations";
import {
  getAllCountriesFulfilledReducer,
  getAllCountriesPendingReducer,
  getAllCountriesRejectedReducer,
  getCountryInfoFulfilledReducer,
  getCountryInfoRejectedReducer,
  getHTMLCodeFulfilledReducer,
  getHTMLCodePendingReducer,
  getHTMLCodeRejectedReducer,
  getMenuProxyFulfilledReducer,
  getMenuProxyPendingReducer,
  getMenuProxyRejectedReducer,
  getPageContentFulfilledReducer,
  getPageContentPendingReducer,
  getPageContentRejectedReducer,
  serverSeoSaveReducer,
} from "./content.reducer";

const contentSlice = createSlice({
  name: "content",
  initialState: contentInitialState,

  extraReducers: builder =>
    builder
      .addCase(serverSeoSave, serverSeoSaveReducer)
      .addCase(serverCountrySave, getAllCountriesFulfilledReducer)
      .addCase(saveCountryInfo, getCountryInfoFulfilledReducer)
      .addCase(serverMenuProxySave, getMenuProxyFulfilledReducer)

      .addCase(getPageContent.pending, getPageContentPendingReducer)
      .addCase(getPageContent.fulfilled, getPageContentFulfilledReducer)
      .addCase(getPageContent.rejected, getPageContentRejectedReducer)

      .addCase(getAllCountries.pending, getAllCountriesPendingReducer)
      .addCase(getAllCountries.fulfilled, getAllCountriesFulfilledReducer)
      .addCase(getAllCountries.rejected, getAllCountriesRejectedReducer)

      .addCase(getCountryInfo.fulfilled, getCountryInfoFulfilledReducer)
      .addCase(getCountryInfo.rejected, getCountryInfoRejectedReducer)

      .addCase(getProxiesMenu.pending, getMenuProxyPendingReducer)
      .addCase(getProxiesMenu.fulfilled, getMenuProxyFulfilledReducer)
      .addCase(getProxiesMenu.rejected, getMenuProxyRejectedReducer)

      .addCase(getHTMLCode.pending, getHTMLCodePendingReducer)
      .addCase(getHTMLCode.fulfilled, getHTMLCodeFulfilledReducer)
      .addCase(getHTMLCode.rejected, getHTMLCodeRejectedReducer),
});

export const ContentActions = {
  getPageContent,
  serverSeoSave,
  getAllCountries,
  serverCountrySave,
  getCountryInfo,
  saveCountryInfo,
  getProxiesMenu,
  serverMenuProxySave,
  getHTMLCode,
};

export default contentSlice.reducer;
